import React from 'react';
import { Controller } from './Controller';
import { Receiver } from './Receiver';

export function withPresentationSupport(controllerWindow: JSX.Element, receiverWindow?: JSX.Element, noPresentationWindow?: JSX.Element) {
    function PresentationSupport() {
        const presentation = navigator.presentation;

        return (
            presentation
                ? presentation.receiver
                    ? <Receiver presentationReceiver={presentation.receiver}>{receiverWindow ?? controllerWindow}</Receiver>
                    : <Controller>{controllerWindow}</Controller>
                : <React.Fragment>{noPresentationWindow ?? controllerWindow}</React.Fragment>
        );
    }

    return <PresentationSupport />;
}
